/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UndercarriageWearTrendResponse } from './UndercarriageWearTrendResponse';
import {
    UndercarriageWearTrendResponseFromJSON,
    UndercarriageWearTrendResponseFromJSONTyped,
    UndercarriageWearTrendResponseToJSON,
    UndercarriageWearTrendResponseToJSONTyped,
} from './UndercarriageWearTrendResponse';
import type { UndercarriageWearPointResponse } from './UndercarriageWearPointResponse';
import {
    UndercarriageWearPointResponseFromJSON,
    UndercarriageWearPointResponseFromJSONTyped,
    UndercarriageWearPointResponseToJSON,
    UndercarriageWearPointResponseToJSONTyped,
} from './UndercarriageWearPointResponse';

/**
 * 
 * @export
 * @interface UndercarriageWearHistoryResponse
 */
export interface UndercarriageWearHistoryResponse {
    /**
     * 
     * @type {string}
     * @memberof UndercarriageWearHistoryResponse
     */
    partType?: string;
    /**
     * 
     * @type {string}
     * @memberof UndercarriageWearHistoryResponse
     */
    location?: string;
    /**
     * 
     * @type {Array<UndercarriageWearTrendResponse>}
     * @memberof UndercarriageWearHistoryResponse
     */
    trends?: Array<UndercarriageWearTrendResponse>;
    /**
     * 
     * @type {number}
     * @memberof UndercarriageWearHistoryResponse
     */
    projectedHoursToLimit?: number | null;
    /**
     * 
     * @type {Array<UndercarriageWearPointResponse>}
     * @memberof UndercarriageWearHistoryResponse
     */
    points?: Array<UndercarriageWearPointResponse>;
}

/**
 * Check if a given object implements the UndercarriageWearHistoryResponse interface.
 */
export function instanceOfUndercarriageWearHistoryResponse(value: object): value is UndercarriageWearHistoryResponse {
    return true;
}

export function UndercarriageWearHistoryResponseFromJSON(json: any): UndercarriageWearHistoryResponse {
    return UndercarriageWearHistoryResponseFromJSONTyped(json, false);
}

export function UndercarriageWearHistoryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UndercarriageWearHistoryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'partType': json['partType'] == null ? undefined : json['partType'],
        'location': json['location'] == null ? undefined : json['location'],
        'trends': json['trends'] == null ? undefined : ((json['trends'] as Array<any>).map(UndercarriageWearTrendResponseFromJSON)),
        'projectedHoursToLimit': json['projectedHoursToLimit'] == null ? undefined : json['projectedHoursToLimit'],
        'points': json['points'] == null ? undefined : ((json['points'] as Array<any>).map(UndercarriageWearPointResponseFromJSON)),
    };
}

export function UndercarriageWearHistoryResponseToJSON(json: any): UndercarriageWearHistoryResponse {
    return UndercarriageWearHistoryResponseToJSONTyped(json, false);
}

export function UndercarriageWearHistoryResponseToJSONTyped(value?: UndercarriageWearHistoryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'partType': value['partType'],
        'location': value['location'],
        'trends': value['trends'] == null ? undefined : ((value['trends'] as Array<any>).map(UndercarriageWearTrendResponseToJSON)),
        'projectedHoursToLimit': value['projectedHoursToLimit'],
        'points': value['points'] == null ? undefined : ((value['points'] as Array<any>).map(UndercarriageWearPointResponseToJSON)),
    };
}

